// ─────────────────────────────────────────────────────────────────────────────
// Cari (Customer) API — /api/customers uclari.
// Her cagri once ensureSession() ile oturumu garanti eder.
// ─────────────────────────────────────────────────────────────────────────────

import { logoRequest } from './client';
import { ensureSession } from './session';
import { Customer, CustomerFilter, LogoResult } from '../types';

// CustomerFilter alanlarini query string'e cevirir (bos/undefined atlanir).
function toQuery(f: CustomerFilter = {}): Record<string, string | number | boolean> {
  const q: Record<string, string | number | boolean> = {};
  if (f.onlyActive !== undefined) q.OnlyActive = f.onlyActive;
  if (f.code) q.Code = f.code;
  if (f.title) q.Title = f.title;
  if (f.contact) q.Contact = f.contact;
  if (f.city) q.City = f.city;
  if (f.town) q.Town = f.town;
  if (f.countryCode) q.CountryCode = f.countryCode;
  if (f.country) q.Country = f.country;
  if (f.zipCode) q.ZipCode = f.zipCode;
  if (f.phone) q.Phone = f.phone;
  if (f.email) q.Email = f.email;
  if (f.specode1) q.Specode1 = f.specode1;
  if (f.specode2) q.Specode2 = f.specode2;
  if (f.groupCode) q.GroupCode = f.groupCode;
  if (f.cardType !== undefined) q.CardType = f.cardType;
  return q;
}

/** GET /api/customers — filtreli cari listesi. */
export async function getCustomers(filter: CustomerFilter = {}): Promise<LogoResult<Customer[]>> {
  await ensureSession();
  return logoRequest<Customer[]>({ url: '/api/customers', method: 'GET', params: toQuery(filter) });
}

/** GET /api/customers/{code} — tek cari. */
export async function getCustomer(code: string): Promise<LogoResult<Customer>> {
  await ensureSession();
  return logoRequest<Customer>({ url: `/api/customers/${encodeURIComponent(code)}`, method: 'GET' });
}

/** POST /api/customers — Logo'ya cari ekle/guncelle (insert icin id=0). */
export async function saveCustomer(customer: Customer): Promise<LogoResult<Customer>> {
  await ensureSession();
  return logoRequest<Customer>({ url: '/api/customers', method: 'POST', data: customer });
}

/**
 * POST /api/customers/bulk — toplu cari gonderimi.
 * allowUpdate (query, varsayilan true): var olan kayitlar guncellensin mi.
 */
export async function saveCustomersBulk(
  customers: Customer[],
  allowUpdate = true,
): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest<unknown>({
    url: '/api/customers/bulk',
    method: 'POST',
    params: { allowUpdate },
    data: customers,
  });
}
